
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '¿Qué productos de limpieza utilizan?',
      answer: 'Utilizamos productos eco-friendly, biodegradables y seguros para niños y mascotas. Todos nuestros productos están certificados y no contienen químicos tóxicos.'
    },
    {
      question: '¿Cuánto tiempo toma una limpieza típica?',
      answer: 'El tiempo varía según el tamaño y tipo de servicio. Una limpieza residencial estándar toma entre 2-4 horas, mientras que una limpieza profunda puede tomar 4-6 horas.'
    },
    {
      question: '¿Cuál es su política de cancelación?',
      answer: 'Puedes cancelar o reprogramar tu cita hasta 24 horas antes sin ningún cargo. Cancelaciones con menos de 24 horas de anticipación pueden tener una tarifa de cancelación.'
    },
    {
      question: '¿Ofrecen garantía en su trabajo?',
      answer: 'Sí, ofrecemos una garantía de satisfacción del 100%. Si no estás completamente satisfecho con nuestro trabajo, regresaremos dentro de 24 horas para corregir cualquier problema sin costo adicional.'
    },
    {
      question: '¿Qué debo incluir en mi solicitud de cotización?',
      answer: 'Incluye el tipo de propiedad, número de habitaciones y baños, tipo de servicio deseado, frecuencia preferida y cualquier área que requiera atención especial.'
    },
    {
      question: '¿Cómo debo preparar mi hogar para la limpieza?',
      answer: 'Recoge objetos personales y artículos de valor. Asegúrate de que tengamos acceso a todas las áreas a limpiar. No es necesario hacer limpieza previa, ¡para eso estamos nosotros!'
    },
    {
      question: '¿Puedo reprogramar mi cita?',
      answer: 'Por supuesto. Puedes reprogramar tu cita hasta 24 horas antes del servicio programado sin ningún cargo adicional. Contáctanos y encontraremos una nueva fecha que funcione para ti.'
    },
    {
      question: '¿Están asegurados y verificados?',
      answer: 'Sí, estamos completamente asegurados y todos nuestros empleados pasan por verificaciones de antecedentes. Tu seguridad y tranquilidad son nuestra prioridad.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 font-outfit">
            Preguntas Frecuentes
          </h2>
          <p className="text-xl text-slate-600 font-inter">
            Resolvemos las dudas más comunes sobre nuestros servicios
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
                aria-expanded={openIndex === index}
              >
                <h3 className="text-lg font-semibold text-slate-900 font-outfit pr-4">
                  {faq.question}
                </h3>
                <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-sky-500 text-xl flex-shrink-0`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-4">
                  <p className="text-slate-600 leading-relaxed font-inter">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
